// Expose UI version; bump this value on each push
export const APP_VERSION = '0.1.8';
/** Widget version this admin is built to work with (match @shaunstapes/proctoring-widget) */
export const WIDGET_VERSION = '0.5.107';
/** Short description for admin UI (shown in header) */
export const APP_DESCRIPTION = 'Proctoring admin — monitor exams, webcam, verify';
